































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { ticketClient } from "@/api/index";
import {
  GetBasicTicketAttrsReq,
  GetTicketAttrsReq
} from "@/pbjs/external/ticket/ticket_pb";

import { timeFormat } from "@/utils/index.ts";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage } from "@/utils/request";
import { setMetaData } from "@/utils/index";

@Component({
  name: "CombinationProperty"
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = [];
  @Provide() private token: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private searchText: string = "";
  @Provide() private isGetBasicTicketAttrsActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;

  private created() {
    this.token = localStorage.getItem("token");
    this.getBasicTicketAttrsAction();
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getBasicTicketAttrs();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getBasicTicketAttrs();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getBasicTicketAttrs();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getBasicTicketAttrs();
  }

  private getBasicTicketAttrsAction() {
    this.isGetBasicTicketAttrsActionDone = true;
    this.pageIndex = 1;
    this.getBasicTicketAttrs();
  }
  private getBasicTicketAttrs() {
    let request: any = new GetBasicTicketAttrsReq();
    request.setCommonin(setCommon());
    request.setAttrtype(0);
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    request.setFiltername(this.searchText);
    ticketClient.getBasicTicketAttrs(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (data.commonout) {
            if (data.commonout.code == 0) {
              if (data.listList) {
                data.listList.forEach((item: any) => {
                  item.ctime = timeFormat(item.ctime);
                });
                this.resultData = data.listList;
              }
              this.pagerCount = data.pageout.total; // 匹配总条数
            } else if (
              data.commonout.code == 100100 ||
              data.commonout.code == 100101
            ) {
              this.$router.push("./login");
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          } else {
            if (data.code == 0) {
              if (data.listList) {
                data.listList.forEach((item: any) => {
                  item.ctime = timeFormat(item.ctime);
                });
                this.resultData = data.listList;
              }
            } else if (data.code == 100100 || data.code == 100101) {
              this.$router.push("./login");
            } else {
              this.$message.error(data.errmsg);
            }
          }
        }
        this.isGetBasicTicketAttrsActionDone = false;
      }
    );
  }

  private getTicketAttrs() {
    let request: any = new GetTicketAttrsReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    ticketClient.getTicketAttrs(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (data.commonout) {
            if (data.commonout.code == 0) {
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          } else {
            if (data.code == 0) {
            } else {
              this.$message.error(data.errmsg);
            }
          }
        }
      }
    );
  }

  // private getTicketAttrByName() {
  //     let request:any = new GetTicketAttrByNameReq();
  //     request.setTrackid("");
  //     request.setClientid("");
  //     request.setToken(this.token);
  //     request.setName(this.searchText);
  //     ticketClient.getTicketAttrByName(request, {}, (err: any, response:any) => {
  //         if(response) {
  //             let data:any = response.toObject();
  //             if (!data.commonout || (data.commonout.code == 0)) {
  //             } else if (data.code == 100100 || data.code == 100101) {
  //                 this.$router.push("./login");
  //             } else {
  //                 this.$message.error(data.commonout.errmsg);
  //             }
  //         }
  //     });
  // }
}
